import { useMutation } from "@tanstack/react-query";
import axios from "../axios-orders";
import { CoordinateOcRequest, PurchaseOrderResponse } from "../types";
import { useInvalidateOc } from "./useOcActions";

export interface CoordinateOcVariables {
  id: string;
  body: CoordinateOcRequest;
}

/**
 * "Coordinar entrega": ACCEPTED -> IN_DELIVERY, creating the OC's linked Delivery. 409 = the OC is
 * no longer ACCEPTED. Refreshes BOTH `[PURCHASE_ORDER, id]` and `[PURCHASE_ORDERS]` (on settle, like
 * every OC action, so a 409 also pulls the real state).
 */
export const useCoordinateOc = () => {
  const invalidate = useInvalidateOc();
  return useMutation<PurchaseOrderResponse, Error, CoordinateOcVariables>({
    mutationFn: async ({ id, body }) => {
      const { data } = await axios.post(
        `/purchase-orders/${id}/coordinate`,
        body
      );
      return data;
    },
    onSettled: (_data, _error, { id }) => invalidate(id),
  });
};
